import axios from "axios";
import React, { useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import Button from "react-bootstrap-button-loader";
import { useLocation } from "react-router-dom";

const AppointmentBookingServiceModal = ({
  showServiceModal,
  setShowServiceModal,
  data,
  branch,
  updateService,
}) => {
  const location = useLocation();

  const baseUrl = localStorage.getItem("API_URL");
  const token = localStorage.getItem("user_token");
  const userDetails = JSON.parse(localStorage.getItem("user_details"));

  const [buttonLoader, setButtonLoader] = useState(false);
  const [allServices, setAllServices] = useState([]);

  const [selectedService, setSelectedService] = useState("");

  // get base url - useEffect
  useEffect(() => {
    if (showServiceModal) {
      if (
        baseUrl.length > 0 &&
        token.length > 0 &&
        Object.keys(userDetails).length > 0
      ) {
        getAllServicesByBranch();
      }

      if (data != null) {
        setSelectedService(data);
      }
    }
  }, [showServiceModal]);

  // get services by branch id - function
  const getAllServicesByBranch = () => {
    axios({
      method: "GET",
      url: `${baseUrl}/category/get-categories/branch/${branch.id}`,
      headers: {
        Authorization: token,
      },
    })
      .then((res) => {
        let data = res.data.data;
        setAllServices(data.list);
      })
      .catch((error) => {
        console.log(error);
        if (error.response !== undefined) {
          toast.error(error.response.data.message, {
            position: "bottom-center",
          });
        } else {
          toast.error("Something went wrong", {
            position: "bottom-center",
          });
        }
      });
  };

  // closeModal - function
  const closeModal = () => {
    setButtonLoader(false);
    setShowServiceModal(false);
  };

  // update service - function
  const UpdateRole = () => {
    updateService(selectedService);
    closeModal();
  };

  return (
    <>
      <div>
        <Toaster />
      </div>
      {showServiceModal ? (
        <div
          className={`modal fade d-block show modal-container`}
          id="counter-modal"
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Services
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    closeModal();
                  }}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>

              <div className="modal-body">
                <div className="row clearfix">
                  <div className="col-lg-12 col-md-12">
                    <div
                      className="row clearfix"
                      style={{ maxHeight: "300px", overflowY: "scroll" }}
                    >
                      {allServices.length > 0 ? (
                        allServices.map((service, index) => (
                          <div
                            className="col-lg-4 col-md-4 p-l-5 p-r-5 mb-2"
                            style={{ height: "fit-content" }}
                            key={index}
                          >
                            <div
                              className={`list-group-item d-flex justify-content-between align-items-center cursor-pointer ${
                                service.id === selectedService.id
                                  ? "active"
                                  : ""
                              }`}
                              title={service.id}
                              onClick={() => {
                                setSelectedService(service);
                              }}
                            >
                              <p className="modal-lg-select-card-text">
                                {service.category}
                              </p>
                            </div>
                          </div>
                        ))
                      ) : (
                        <div class="alert alert-custom alert-dismissible w-100 text-center">
                          <i class="fa fa-info-circle mr-2"></i> Empty records
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-default"
                  onClick={() => {
                    closeModal();
                  }}
                >
                  Cancel
                </button>

                <Button
                  loading={buttonLoader}
                  type="button"
                  className="btn btn-primary"
                  onClick={() => {
                    UpdateRole();
                  }}
                >
                  Save Changes
                </Button>
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default AppointmentBookingServiceModal;
